<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Acessos de cliente' btnLink='$back' btnTxt='Voltar'
        :action="`Acessos do cliente ${company.fantasy}`"/>

      <div class="row">
        <div class="col-lg-9">
          <div class="wrapper wrapper-content animated fadeInUp">

            <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

            <div class="ibox">
                <div class="ibox-content">
                  <div class="row">

                    <div class="col-lg-12">
                      <div class="m-b-md">
                        <button class="btn btn-success btn-outline btn-w-m pull-right" @click="editCompany(company)">
                          <i class="fa fa-pencil"></i> Editar
                        </button>
                        <h2>{{ company.name }}</h2>
                      </div>
                      <dl class="dl-horizontal">
                        <dt>Situação:</dt>
                        <dd v-if="company.status == 1"><span class="label label-primary">Ativo</span></dd>
                        <dd v-if="company.status == 2"><span class="label label-warning">Pendente</span></dd>
                        <dd v-if="company.status == 0"><span class="label label-default">Inativo</span></dd>
                      </dl>
                    </div>

                  </div>

                  <div class="row">

                    <div class="col-sm-6">
                      <dl class="dl-horizontal">
                        <dt>Nome Fantasia:</dt> <dd>{{ company.fantasy }}</dd>
                        <span v-if="company.type == 0">
                          <dt>CNPJ:</dt>
                          <dd> {{ company.document | cnpj }}</dd>
                        </span>
                        <span v-if="company.type == 1">
                          <dt>CPF:</dt>
                          <dd> {{ company.document | cpf }}</dd>
                        </span>
                        <dt>Telefone:</dt> <dd> {{ company.phone | phone }} </dd>
                        <dt>Contato:</dt> <dd><a v-bind:href="`mailto:${company.email}`" class="text-navy"> {{ company.contact }}</a> </dd>
                        <dt>Email:</dt> <dd> {{ company.email }} </dd>
                        <span v-if="company.phone !== company.contact_phone">
                          <dt>Tel contato:</dt> <dd> {{ company.contact_phone | phone }} </dd>
                        </span>
                      </dl>
                    </div>

                    <div class="col-sm-6">
                      <dl class="dl-horizontal">

                        <address>
                          <strong>Endereço:</strong><br>
                          <i class="fa fa-map-marker"></i> {{ company.place }} Nº {{ company.number }}<br>
                          {{ company.city }} - {{ company.state }} <br> {{ company.cep | cep }}
                        </address>

                      </dl>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-lg-12">

                      <dl class="dl-horizontal">
                        <dt>Usuários: </dt> <span v-if="companyUsers.length == 0"> &nbsp;&nbsp;Sem usuários cadastrados </span>
                        <dd class="project-people">
                          <span v-for="user in companyUsers" :key="user.id" style="margin: 2px; cursor: pointer">
                            <span class="image-box">
                              <img :alt="user.name" class="img-circle" :src="user.img || '/static/img/profile.jpg'" @click="editUser(user)">
                              <span class="tooltiptext">{{ user.name }}</span>
                            </span>
                          </span>
                        </dd>
                      </dl>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12 draggable-container">
                      <p class="title">Produtos: </p>

                      <draggable :class="{'animated infinite pulse': dragging}"  @change="update($event)"
                        class="draggable" v-model="companyProducts" :options="{ group:'products', handle: '.none' }">
                        <div class="panel panel-default" v-for="(element, index) in companyProducts" :key="element.id">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-sm-12">

                                <div class="panel-body">
                                  <div class="col-sm-10">
                                    <strong>{{ element.product_name }}</strong>
                                  </div>

                                  <!-- Mantido para fins de desenvolvimento -->
                                  <!-- <button class="btn btn-danger"
                                    @click="deleteCompanyProduct(element.id_company_product)">
                                    <i class="fa fa-trash"></i>
                                  </button> -->

                                  <div class="col-sm-2" style="text-align: right">
                                    <multiselect
                                      v-model="element.status"
                                      id="status"
                                      :options="[0,1,2]"
                                      :custom-label="getStatusLabel"
                                      :searchable="false"
                                      :allow-empty="false"
                                      open-direction="bottom"
                                      placeholder=""
                                      select-label=""
                                      selected-label=""
                                      deselect-label=""
                                      @select="updateStatus(element, index, $event)"
                                      style="max-width: 120px; margin-left: auto;">
                                    </multiselect>

                                  </div>
                                </div>

                              </div>

                            </div>
                            <div v-if="element.users" class="row animated fadeIn">
                              <div class="col-sm-12 product-users">
                                <i class="fa fa-user"></i>
                                <span v-if="element.users.length === 0">Nenhum usuário</span>
                                <div v-if="element.users.length > 0">
                                  <dd class="project-people">
                                    <span v-for="user in element.users" :key="user.id" style="margin: 2px; cursor: pointer">
                                      <span class="image-box">
                                        <img :alt="user.name" class="img-circle" :src="user.img || '/static/img/profile.jpg'" @click="loadModalInfo(element, 'edit', user)" data-toggle="modal" data-target="#userModal">
                                        <span class="tooltiptext">{{ user.name }}</span>
                                      </span>
                                    </span>
                                  </dd>
                                </div>
                                <button @click.prevent="loadModalInfo(element, 'choose_existing')" class="btn btn-success btn-outline add-user-btn img-circle" data-toggle="modal" data-target="#userModal">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </draggable>

                      <p class="empty-text" v-if="companyProducts.length === 0">Nenhum produto associado a este cliente. Arraste e solte os produtos ao lado.</p>

                    </div>

                  </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="wrapper wrapper-content project-manager">
            <h4>Acesso a Produtos</h4>
            <img src="/static/img/logo-ssparisi.png" class="img-responsive">

            <p class="small">
              Nesta área estão disponibilizados todos os produtos da <strong>S.S. Parisi</strong>,
              para permitir o uso pela Empresa, basta arrastar para a <strong>ÁREA DE PRODUTOS</strong> do cliente
              e aguardar a confirmação de <strong>Sucesso.</strong>
            </p>

            <p class="small font-bold">
              <span><i class="fa fa-circle text-warning"></i> Produtos disponíveis: </span>
            </p>

            <ul class="tag-list" style="padding: 0" disabled="true">

              <draggable class="draggable out" v-model="products"
                @start="onDragProduct" style="min-height: 30px;"
                @end="onDropProduct" :options="{ group:{ name:'products', pull: 'clone'} }">

                <div class="panel panel-default" v-for="prod in products" :key="prod.public_key">
                  <div class="panel-body">
                    <div class="media-body">
                      <strong>{{ prod.product_name }}</strong>
                    </div>
                  </div>
                </div>

              </draggable>

            </ul>

          </div>
        </div>

        <!--  ============================== MODAL DE INCLUSÃO DE USUÁRIO ============================= -->
        <div class="modal inmodal fade" id="userModal" tabindex="-1" role="dialog"  aria-hidden="true">
          <div class="modal-dialog" v-if="selectedProduct">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">&times;</span>
                  <span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title" v-if="modalMode === 'create_new' || modalMode === 'choose_existing'">Incluir usuário</h4>
                <h4 class="modal-title" v-if="modalMode === 'edit'">Editar permissões</h4>
                <p v-if="modalMode === 'edit'">Usuário {{user.name}}</p>
              </div>
              <div class="modal-body">

                <div class="form-inline form-group" >
                  <h4>Usuário</h4>
                  <p v-if="modalMode === 'edit'">{{user.name}}</p>
                  <div class="radio-group" v-if="modalMode === 'create_new' || modalMode === 'choose_existing'">
                    <div class="radio i-checks"><label> <input type="radio" @change="alternateNew" value="choose_existing" v-model="modalMode"> <i></i> Escolher usuário existente </label></div>
                    <div class="radio i-checks"><label> <input type="radio" @change="alternateNew" value="create_new" v-model="modalMode"> <i></i> Criar novo usuário </label></div>
                  </div>
                </div>

                <div class="row" v-if="modalMode === 'choose_existing'">
                  <div class="col-lg-12 form-group">
                    <multiselect v-model="user" id="users" :class="{loading: loadingUsers}"
                      placeholder="Procure pelo e-mail"
                      :options="userList"
                      track-by="public_key"
                      :internal-search="false"
                      :close-on-select="true"
                      :local-search="false"
                      :searchable="true"
                      :hide-selected="true"
                      :showLabels="false"
                      :loading="loadingUsers"
                      @search-change="onSearchUsers"
                      @close="onCloseUser">

                      <span slot="option" slot-scope="{ option }">{{option.name }} <small>&lt;{{ option.email}}&gt;</small></span>
                      <span slot="singleLabel" slot-scope="{ option }">{{option.name }} <small v-show="option.email">&lt;{{ option.email}}&gt;</small></span>
                      <span slot="noResult">Nenhum usuário encontrado.</span>
                    </multiselect>
                  </div>
                </div>

                <div class="row" v-if="modalMode === 'create_new'">
                  <div class="col-lg-6 form-group required">
                    <label for="email" class="sr-only control-label" :class="{invalid: errors.has('email')}"> email </label>
                    <input type="email" name="email" class="form-control" placeholder="Email"
                      v-model="user.email" v-validate="'required|email'" :class="{ invalid: errors.has('email') }" >
                    <span class="error">{{ errors.first('email') }}</span>
                  </div>
                  <div class="col-lg-6 form-group">
                    <label for="nome" class="sr-only control-label" :class="{invalid: errors.has('nome')}"> name </label>
                    <input type="nome" name="nome" class="form-control" placeholder="Nome (opcional)"
                      v-model="user.name" v-validate="'min:2'" :class="{ invalid: errors.has('nome') }" >
                    <span class="error">{{ errors.first('nome') }}</span>
                  </div>
                </div>

                <h4>Permissões</h4>
                <div v-if="permissions.length > 0">
                  <div class="row">
                    <div class="col-sm-12">
                      <button class="btn btn-small btn-white pull-right all-btn" @click.prevent="checkAll()"><i class="fa fa-check"></i> Marcar todas </button>
                    </div>
                  </div>
                  <div class="list-group">
                    <a v-for="perm in permissions" :key="perm.public_key" :class="[`level-${ perm.level }`, {checked: perm.allow_access}]" class="list-group-item no-pointer">
                      {{ perm.description }}
                      <input @change="modifyChildren(perm)" type="checkbox" class="i-checks pull-right" v-model="perm.allow_access"/>
                    </a>
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <p v-if="removeAccess" class="alert alert-danger left animated fadeInDown"><strong>Atenção:</strong> desmarcar todas as permissões removerá o acesso de <strong>{{user.name}}</strong> no <strong>{{selectedProduct.product_name}}</strong> nesta empresa.</p>
                <p v-if="!removeAccess && noPermissionSelected" class="alert alert-warning left animated fadeInDown">Nenhuma permissão selecionada.</p>

                <button type="button" class="btn btn-w-m btn-white" data-dismiss="modal" ref="closeModal"> Cancelar </button>

                <button v-show="!removeAccess" type="button" class="btn btn-w-m btn-success" data-dismiss="modal" @click.prevent="includeUser(user)" :disabled="noPermissionSelected">
                  <span v-show="modalMode === 'create_new'">Criar e incluir</span>
                  <span v-show="modalMode === 'choose_existing'">Incluir</span>
                  <span v-show="modalMode === 'edit'">Salvar</span>
                </button>

                <button class="btn btn-w-m btn-danger pull-left" @click.prevent="removeUserAccess(user).then(() => getCompanyUsers() )" :disabled="disable">Excluir</button>

                <button v-if="removeAccess" type="button" class="btn btn-w-m btn-danger" data-dismiss="modal" @click.prevent="removeUserAccess(user).then(() => getCompanyUsers())">
                  Remover acesso
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

import NavMenu from './layout/NavMenu'
import SideMenu from './layout/SideMenu'
import BreadCrumps from './layout/BreadCrumps'
import PageFooter from './layout/PageFooter'
import Spinner from './layout/Spinner'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'

import { mapGetters } from 'vuex'
import { httpService } from '../providers/http-service'
import { helper } from '../mixins/helper'
import { toast } from '../mixins/toast'
import { errorMessage } from '../mixins/error-message'
import { permissions } from '../mixins/permissions'
import { permissionManager } from '../mixins/permission-manager'

  export default {
    mixins: [ helper, toast, errorMessage, permissions, permissionManager ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, draggable, Spinner, Multiselect },
    data () {
      return {
        company: { },
        dragging: false,
        disable: false,
        showSpinner: false,
        companyProducts: [],
        companyUsers: [],
        products: [ ],
        //User
        modalMode: 'choose_existing',
        user: null,
        loadingUsers: false,
        userList: [],
        users:[]
      }
    },
    methods: {
      ...mapGetters(['getCompany']),

      editCompany(company) {
        this.checkPermissions(company.public_key, '8a2fd41ee4b3be69484fb1114cc95341', 'alterar este cliente')
        .then((isPermited) => {
          if(isPermited){
            company.activities = JSON.stringify(company.activities)
            this.$router.push({ path: '/company/create', query: company })
          }
        })
      },

      onDragProduct() {
        this.dragging = this.companyProducts.length === 0
      },

      onDropProduct() {
        this.companyProducts = [...new Set(this.companyProducts)]
        this.dragging = false
      },

      update(ev) {
        this.checkPermissions(this.company.public_key, '3e3fc7d1f943ad6bfe6c6b056873ce8e', 'Adicionar produtos')
        .then((isPermited) => {
          if(isPermited){
            this.saveCompanyProduct(ev.added.element.product_public_key, this.company.public_key)
          } else {
            this.companyProducts.splice(ev.added.element, 1)
          }
        })
      },

      editUser(user) {
        this.checkPermissions(this.company.public_key, '11d0632099c633b1dd73b9bac676a621', 'Editar Usuário')
        .then((isPermited) => {
          if(isPermited){
            this.$router.push({ path: '/users/create', query: user })
          }
        })
      },

      updateStatus(el, idx, status) {
        this.disable = true
        this.showSpinner = true
        this.checkPermissions(this.company.public_key, '3e3fc7d1f943ad6bfe6c6b056873ce8e', 'Ativar/Inativar Produtos')
        .then((isPermited) => {
          if(isPermited) {
            httpService.changeProductStatus(el.id_company_product, status).then((res) => {
              if(res.status == 200) {
                this.disable = false
                this.showSpinner = false
                this.show_toast('success', 'Sucesso', 'Produto Atualizado com sucesso!')
              }
            }).catch((err) => {
              this.disable = false
              this.showSpinner = false
              this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
            })
          } else {
            this.disable = false
            this.showSpinner = false
          }
        })
      },

      saveCompanyProduct(prd, comp) {
        this.showSpinner = true
        httpService.setCompanyProduct(prd, comp).then((res) => {
          if(res.status == 200) {
            this.getCompanySavedProducts().then(() => {
              this.showSpinner = false
              this.show_toast('success', 'Sucesso', 'Produto adicionado com sucesso!')
            })
          }
        }).catch((err) => {
          this.showSpinner = false
          if(err.message === 'Request failed with status code 400') {
            this.companyProducts.splice(prd, 1)
            this.show_toast('warning', 'Atenção', 'Você já possui esse produto na lista!')
          } else {
            this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
          }
        })
      },

      deleteCompanyProduct(prd) {
        this.showSpinner = true
        return new Promise((resolve, reject) => {
          httpService.removeCompanyProduct(prd).then((res) => {
            if(res.status == 200) {
              this.showSpinner = false
              this.show_toast('success', 'Sucesso', 'Produto removido com sucesso!')
              resolve(true)
            } else { resolve(false) }
          }).catch((err) => {
            this.showSpinner = false
            this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
            resolve(false)
          })

        })
      },

      getAvailableProducts() {
        return httpService.getCompanyProducts(this.getCompany().public_key).then((res) => {
          this.products = res.data
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      getCompanySavedProducts() {
        return httpService.getCompanyProducts(this.company.public_key).then((res) => {
          this.companyProducts = res.data
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      getCompanyUsers() {
        return httpService.getCompanyUsers(this.company.public_key, { filter: '', page: 0, limit: 1000 }).then(res => {
          this.companyUsers = res.data
          this.companyProducts.forEach(prod => {
            prod.users = this.companyUsers.filter(usr => {
              return (usr.products.filter(prd => prd.public_key === prod.product_public_key)).length > 0
            })
          })
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      loadModalInfo(product, modalMode, user = {}) {
        this.selectedProduct = product
        this.modalMode = modalMode
        this.user = user
        this.permissions = []
        if(this.user) {
          this.getUserPermissions(product)
        } else {
          this.getProductPermissions(product)
        }
      },

      includeUser() {
        this.showSpinner = true;
        (this.modalMode === 'create_new' ? httpService.saveNewUser(this.user) : Promise.resolve({ data: [this.user] }))
        .then(res => {
          this.user = res.data[0]
          return httpService.saveUserPermissions(this.company.public_key, this.selectedProduct.product_public_key, this.user.public_key, this.permissions.filter(perm => !perm.allow_access).map(perm => perm.public_key))
        })
        .then(() => this.modalMode === 'create_new' ? httpService.sendUserEnvite(this.user.email) : Promise.resolve())
        .then(() => {
          this.showSpinner = false
          this.show_toast('success', '', 'Usuário associado com sucesso!')
          this.getCompanyUsers()
        })
        .catch(err => this.showErrorMessage({ err: err }))
      },

      alternateNew() {
        this.user = this.modalMode === 'create_new' ? {} : null
      },

      onSearchUsers(search) {
        if(!search) { return }
        this.loadingUsers = true
        this.searchUsers(search, this)
      },

      searchUsers: _.debounce((search, component) => {
        const query = {
          filter: { field: 'email', value: search },
          limit: 20,
          page: 0
        }
        httpService.getCompanyUsers(component.getCompany().public_key, query).then(res => {
          component.userList = res.data
        }).catch(err => {
          component.showErrorMessage({err: err})
        }).finally(() => {
          component.loadingUsers = false
        })
      }, 350),

      onCloseUser() { this.userList = [] },

      getStatusLabel(status) {
        return {
          0: 'Inativo',
          1: 'Ativo',
          2: 'Bloqueado'
        }[status]
      },

      initialize() {
        this.showSpinner = true
        this.company = this.$route.query
        this.getAvailableProducts().then(() => {
          this.getCompanySavedProducts().then(() => {
            this.getCompanyUsers().then(() => {
              this.showSpinner = false
            })
          })
        })
      }
    },

    mounted() {
      this.initialize()
    }
  }
</script>

<style scoped>

  .img-circle.logo{
    width: 30px;
    margin-right:10px;
  }

  .image-box img:hover {
    opacity: 0.5;
    border: 2px solid #1ab394;
  }

  .tooltiptext {
    top: 30px;
    visibility: hidden;
    width: 120px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
  }

  .image-box:hover .tooltiptext {
    visibility: visible;
  }

  .col-sm-1 {
    margin-top: 10px;
  }

  .draggable-container .title{
    font-size: 16px;
    margin-bottom: 10px;
  }

  .img-responsive {
    max-width: 200px;
  }

  .draggable-container .empty-text {
    text-align: center;
    font-size: 13px;
    margin: 5px;
  }

  .add-user-btn {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .product-users {
    padding: 5px 20px;
  }

  .product-users .fa.fa-user {
    font-size: 20px;
    padding-right: 6px;
    margin-right: 4px;
    line-height: 35px;
    border-right: 1px solid #cfcfcf;
  }

  .product-users .img-circle {
    margin-bottom: 6px;
  }

  .product-users div, .product-users dd { display: inline; }

  /* MODAL */
  .modal-dialog { margin-top: 40px; }
  .modal-body { background-color: inherit; }
  .radio-group .radio { margin: 0 10px 0 0; }
  .level-1 { margin-left: 0px;  }
  .level-2 { margin-left: 20px; }
  .all-btn { margin-bottom: 10px; }
  .list-group { max-height: 340px; overflow-x: hidden; overflow-y: auto; }
  .label small { margin: 2px 5px; }
  .left { text-align: left; }

</style>



// WEBPACK FOOTER //
// src/components/CompanyAccessPage.vue